import React from 'react';
import { getInterestChannelList } from 'api/operation';
import { ChannelItemBasic } from 'types/common';

let globalData:ChannelItemBasic[] = [];

const useInterestChannels = ():[ChannelItemBasic[], boolean] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<ChannelItemBasic[]>(globalData);
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getInterestChannelList();
            if (!result.error) {
                const data:ChannelItemBasic[] = result?.data?.data || [];
                globalData = data;
                setItems(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (!loading) {
            fetchData();
        }
    }, []);

    return [items, loading];
};

export default useInterestChannels;
